import type { BackendEntitiesFromBackend } from '../types';

import { URL } from '../../../constants';
import { ServiceConfig } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';
import { transformCategories } from './transform-categories';

// ---

export const getPrematchCategories = (config: ServiceConfig) => {
  type AdapterProps = { response: BackendEntitiesFromBackend['diff'] };

  return defaultRequestService<
    AdapterProps,
    ReturnType<typeof transformCategories>
  >(URL.PREMATCH_CATEGORIES, config.instance.get, {
    responseHandler: transformCategories,
  });
};
